// extracted by mini-css-extract-plugin
module.exports = {"Sidebar":"Sidebar_Sidebar__bZRK2","is-open":"Sidebar_is-open__m0zs4","is-opened":"Sidebar_is-opened__y8Tep","Inset":"Sidebar_Inset__CP8m2"};